import React from 'react';
import uniqid from 'uniqid';
import { Link as RouterLink } from 'react-router-dom';
import ResponsiveWrapper from 'components/shared/others/responsive-wrapper/responsive-wrapper';
import Links from 'containers/user/learn/components/links/links';
import SeeAllButton from 'containers/user/learn/components/see-all-button/see-all-button';

interface CategoryContentItem {
  name?: string;
  coverDescription?: string;
  route: string;
  coverImage?: string;
}

interface CategoryContentProps {
  items: CategoryContentItem[];
  title: string;
  subtitle: string;
  categoryLink: string;
}

const CategoryContent = ({
  items,
  title,
  subtitle,
  categoryLink,
}: CategoryContentProps): React.JSX.Element => {
  const isArticle = title === 'Articles';

  return (
    <ResponsiveWrapper customClass="mobile:mt-12 xs:mt-20">
      <div className="text-navy-800 mb-6">
        <div className="text-4xl font-semibold mb-1">{title}</div>
        <div className="font-semibold text-lg">{subtitle}</div>
      </div>

      <div
        className={
          !isArticle
            ? 'grid mobile:grid-cols-1 tablet:grid-cols-2 xs:grid-cols-3 lg:grid-cols-4 gap-6'
            : 'w-full'
        }
      >
        {!isArticle ? (
          items.map(({ name, coverDescription, route, coverImage }) => (
            <RouterLink
              to={route}
              key={uniqid()}
              className="border border-navy-200 rounded w-full"
            >
              {coverImage ? (
                <img
                  src={coverImage}
                  alt={`${title} ${name}`}
                  className="block w-full h-auto rounded-tl rounded-tr"
                />
              ) : (
                <div className="w-full aspect-[16/10] tablet:bg-bottom categories-bg rounded-tl rounded-tr"></div>
              )}
              <div className="text-neutral-900 text-xl font-semibold pt-4 px-4 pb-2">
                {name}
              </div>
              <div className="text-neutral-900 text-base px-4 pb-4">
                {coverDescription}
              </div>
            </RouterLink>
          ))
        ) : (
          <Links items={items} />
        )}
      </div>

      <SeeAllButton route={categoryLink} contentType={title.toLowerCase()} />
    </ResponsiveWrapper>
  );
};

export default CategoryContent;
